var _g, _g2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIndia(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 27,
    viewBox: "0 0 26 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "in (2) 1",
    clipPath: "url(#clip0_4765_18727)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Mask group"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4765_18727",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 26,
    height: 27
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M13 26.6191C20.1797 26.6191 26 20.7988 26 13.6191C26 6.43944 20.1797 0.619141 13 0.619141C5.8203 0.619141 0 6.43944 0 13.6191C0 20.7988 5.8203 26.6191 13 26.6191Z",
    fill: "white"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_4765_18727)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M0 8.74414L13 7.11914L26 8.74414V18.4941L13 20.1191L0 18.4941V8.74414Z",
    fill: "#EEEEEE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M0 0.619141H26V8.74414H0V0.619141Z",
    fill: "#FF9811"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M0 18.4941H26V26.6191H0V18.4941Z",
    fill: "#6DA544"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M13 17.2754C15.0193 17.2754 16.6562 15.6384 16.6562 13.6191C16.6562 11.5998 15.0193 9.96289 13 9.96289C10.9807 9.96289 9.34375 11.5998 9.34375 13.6191C9.34375 15.6384 10.9807 17.2754 13 17.2754Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M13 16.0566C14.3462 16.0566 15.4375 14.9653 15.4375 13.6191C15.4375 12.2729 14.3462 11.1816 13 11.1816C11.6538 11.1816 10.5625 12.2729 10.5625 13.6191C10.5625 14.9653 11.6538 16.0566 13 16.0566Z",
    fill: "#EEEEEE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M13 14.8379C13.6731 14.8379 14.2188 14.2922 14.2188 13.6191C14.2188 12.946 13.6731 12.4004 13 12.4004C12.3269 12.4004 11.7812 12.946 11.7812 13.6191C11.7812 14.2922 12.3269 14.8379 13 14.8379Z",
    fill: "#0052B4"
  })))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4765_18727"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 26,
    fill: "white",
    transform: "translate(0 0.619141)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIndia);
export default __webpack_public_path__ + "static/media/india.c5f53f31ac7e96d708fc2f8e7c3257ae.svg";
export { ForwardRef as ReactComponent };